import { createActions, createReducer } from 'reduxsauce';
import * as Immutable from 'seamless-immutable';
import * as R from 'ramda';

/* ------------- Types and Action Creators ------------- */
const tag = '[SAGA_EMAIL_REDUX]'; // eslint-disable-line

const functionDefinitions = {

  /*---------- sagaUISendEmail --------*/
  requestSagaUISendEmail: ['emailData'],
  sagaUISendEmailSuccess: ['sagaUISendEmailResponse'],
  sagaUISendEmailFailure: ['sagaUISendEmailError'],

  /*---------- sagaUISendEmail --------*/
  clearSagaEmailState: []

};


const { Types, Creators } = createActions(functionDefinitions);

export const SagaEmailTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const SagaEmailInitState = {
  sagaUISendEmailFetching: false,
  sagaUISendEmailResponse: null,
  sagaUISendEmailError: null,
  emailData: null,
};

export const INITIAL_STATE = Immutable(SagaEmailInitState);

/* ------------- Reducers ------------- */

/*---------- sagaUISendEmail --------*/
export const requestSagaUISendEmail = (state, action) => {
  return state.merge(
    {
      sagaUISendEmailFetching: true,
      emailData: action.emailData,
      sagaUISendEmailResponse: null,
      sagaUISendEmailError: null,
    });
};
export const sagaUISendEmailSuccess = (state, action) => {
  return state.merge(
    {
      sagaUISendEmailFetching: false,
      sagaUISendEmailResponse: action.sagaUISendEmailResponse,
    });
};
export const sagaUISendEmailFailure = (state, action) => {
  return state.merge(
    {
      sagaUISendEmailFetching: false,
      sagaUISendEmailError: action.sagaUISendEmailError,
    });
};

/*---------- clearSagaEmailState --------*/
export const clearSagaEmailState = (state) => {
  return state.merge(SagaEmailInitState);
};

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {

  /*---------- sagaUISendEmail --------*/
  [Types.REQUEST_SAGA_U_I_SEND_EMAIL]: requestSagaUISendEmail,
  [Types.SAGA_U_I_SEND_EMAIL_SUCCESS]: sagaUISendEmailSuccess,
  [Types.SAGA_U_I_SEND_EMAIL_FAILURE]: sagaUISendEmailFailure,

  /*---------- clearSagaEmailState --------*/
  [Types.CLEAR_SAGA_EMAIL_STATE]: clearSagaEmailState,
  
});


// WEBPACK FOOTER //
// ./src/redux/sagaEmail/sagaEmailRedux.ts